import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {PbiTable, ReportLayout} from "./layout";
import {DropdownSlicer, ListSlicer} from "./slicers";
import useSlicers, {MONTH_OPTIONS} from "./slicer-state";
import useReport from "./use-report";
import {build_filters} from "./utils";

/** @module Pages/Reports/Colaborador */

// Anchos de columna del visual del Power BI (px).
const WIDTHS = {persona: 256, fecha_visita: 106, centro_costo: 152};

/**
 * Página "Por colaborador" del Power BI: segmentador de Nombres completos, tabla de visitas y
 * segmentadores de Año y Mes a la derecha.
 */
const ReportColaborador = () => {
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const {slicers, set, yearOptions} = useSlicers(token);
    const filters = useMemo(() => build_filters({...slicers, centro: null}), [slicers]);
    const {data, loading, error, loadMore} = useReport(token, "colaborador", filters);

    return (
        <ReportLayout title="Por colaborador" token={token} body={{type: "colaborador", filters}}
                      loading={loading} error={error}>
            <div className="pbi-page pbi-page--colaborador">
                <div className="pbi-page__main">
                    <div className="pbi-page__top">
                        <DropdownSlicer title="Nombres completos" field="nombre" token={token}
                                        value={slicers.nombre} onChange={set("nombre")}/>
                    </div>
                    <PbiTable data={data} widths={WIDTHS} loading={loading} onLoadMore={loadMore}/>
                </div>
                <div className="pbi-page__side">
                    <ListSlicer title="Año" options={yearOptions} value={slicers.year} onChange={set("year")}/>
                    <ListSlicer title="Mes" options={MONTH_OPTIONS} value={slicers.month} onChange={set("month")}/>
                </div>
            </div>
        </ReportLayout>
    );
};

export default ReportColaborador;
